import http from "@/settings/apiSettings"

class ConcediiDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post('/PER_VacationTypes', data)
    }
}
export default new ConcediiDataService()